var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"send-sms-code",attrs:{"type":"text","loading":_vm.loading,"disabled":Boolean(_vm.countDown),"size":"small"},on:{"click":_vm.handleSendSMSCode}},[_vm._v(" "+_vm._s(_vm.message)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }